import ViewFactory from "../../../helpers/viewfactory";

export default function view() {
  const { $charge } = this;

  return (view = ViewFactory({
    NAME: 'PAGA_INIT_VIEW',
    constants: { hasBackAction: false },
    next() {
      $charge.init({});
    }
  }).call(this));
}
